import type { FC } from 'react'

import { Translation } from '@/app/translations/Translation'
import type { Employee } from '@/resources/employees'
import { getNormalizedPhoneNumber } from '@/util/formatters/phoneNumbers'

import './selected-user.scss'

const SelectedUser: FC<{ employee: Employee | undefined; isForLocation?: boolean }> = ({
  employee,
  isForLocation,
}) => {
  if (!employee) return null

  const { code, name, departmentName, departmentCode, employeeNo } = employee

  return (
    <div className="selected-user">
      <span className="selected-user__name">{name}</span>

      <span className="selected-user__department">
        {departmentCode} {departmentName}
      </span>

      <span className="selected-user__code">
        <small>
          <Translation id={isForLocation ? 'Location' : 'Phone number'} />
        </small>
        <div>{getNormalizedPhoneNumber(code)}</div>
      </span>

      {employeeNo && (
        <span className="selected-user__employee-no">
          <small>
            <Translation id="Employee number" />
          </small>
          <div>{employeeNo}</div>
        </span>
      )}
    </div>
  )
}

export default SelectedUser
